import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => {
        // The standalone Catalog Graph page renders an empty visualizer when
        // reached with no URL params — the plugin requires `rootEntityRefs[]`
        // to know what to draw. Default the sidebar link to the AGM root group
        // so the page lands populated with the full org → systems → components
        // → APIs graph on first click. Per-entity Relations cards keep working
        // independently of this override.
        const href =
          item.href === '/catalog-graph'
            ? '/catalog-graph?rootEntityRefs%5B%5D=group%3Adefault%2Fagm&maxDepth=4'
            : item.href;
        return <SidebarItem icon={() => item.icon} to={href} text={item.title} />;
      });

      // Skipped items — these are rendered manually below, so remove from
      // the default nav.rest() pool to avoid duplicates in the sidebar.
      nav.take('page:search'); // Using SidebarSearchModal instead
      nav.take('page:notifications'); // Using <NotificationsSidebarItem /> (with badge)

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:catalog')}
            {nav.take('page:scaffolder')}
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
